import React from 'react';
export default function HorizontalFunnelChartSkeleton() {
  return /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 1000 397",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "none",
    height: "100%",
    width: "100%"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,158.8L25,158.8C250,158.8,250,208.425,475,208.425L525,208.425C750,208.425,750,212.93636363636364,975,212.93636363636364L1000,212.93636363636364L1000,216.54545454545456L975,216.54545454545456C750,216.54545454545456,750,297.75,525,297.75L475,297.75C250,297.75,250,397,25,397L0,397Z",
    style: {
      opacity: 1,
      // stroke: 'rgb(51, 105, 117)',
      // fill: 'rgb(51, 105, 117)'
      stroke: '#757575',
      fill: '#757575'
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,79.39999999999998L25,79.39999999999998C250,79.39999999999998,250,148.875,475,148.875L525,148.875C750,148.875,750,198.5,975,198.5L1000,198.5L1000,212.93636363636364L975,212.93636363636364C750,212.93636363636364,750,208.425,525,208.425L475,208.425C250,208.425,250,158.8,25,158.8L0,158.8Z",
    style: {
      opacity: 1,
      // stroke: 'rgb(94, 191, 213)',
      // fill: 'rgb(94, 191, 213)',
      stroke: '#BDBDBD',
      fill: '#BDBDBD'
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0L25,0C250,0,250,99.25,475,99.25L525,99.25C750,99.25,750,180.45454545454547,975,180.45454545454547L1000,180.45454545454547L1000,198.5L975,198.5C750,198.5,750,148.875,525,148.875L475,148.875C250,148.875,250,79.39999999999998,25,79.39999999999998L0,79.39999999999998Z",
    style: {
      opacity: 1,
      // stroke: 'rgb(190, 229, 238)',
      // fill: 'rgb(190, 229, 238)'
      stroke: '#EEEEEE',
      fill: '#EEEEEE'
    }
  }));
}